/** Έλεγχος αν έχει συμπληρωθεί βάρος παράδοσης */
export const hasReceptionNetWeight = (weight: unknown) =>
  weight != null && weight !== '' && Number(weight) > 0;

/** Έλεγχος αν έχει συμπληρωθεί ημερομηνία παράδοσης */
export const hasDateStorage = (date: unknown) => date != null && date !== '';
